<template>
  <PopupPane class="MultichoiceOptionPane" v-bind="{ goBack, hidePopup }">
    <LeadFormOption v-if="selectedOption === 'leadForm'"
      :segment="content.segment"
      :whenSubmitted="pushLeadFormConversionEvent"
      v-bind="{ hidePopup }"
    />
    <GatedContentOption v-else-if="selectedOption === 'gatedContent'"
      :content="content.gatedContent"
      :whenSubmitted="pushGatedContentConversionEvent"
    />
    <CaseStudiesOption v-else-if="selectedOption === 'caseStudies'"
      :items="content.caseStudies"
      :whenLinkFollowed="pushCaseStudyClickedEvent"
    />
  </PopupPane>
</template>

<script>
import { pushAnalyticsEvent } from '~/lib/analyticsEvents.js'

import CaseStudiesOption from './CaseStudiesOption.vue'
import GatedContentOption from './GatedContentOption.vue'
import LeadFormOption from './LeadFormOption.vue'
import PopupPane from './PopupPane.vue'

function pushPopupAnalyticsEvent(action, { prompt, segment }, extraFields = {}) {
  pushAnalyticsEvent({
    scope: 'multichoicePromoPopup',
    action,
    content: {
      prompt,
      segment,
      ...extraFields,
    },
  })
}

export default {
  components: {
    PopupPane,
    LeadFormOption,
    GatedContentOption,
    CaseStudiesOption,
  },
  props: {
    goBack: Function,
    hidePopup: Function,
    selectedOption: String,
    content: Object,
  },
  methods: {
    pushLeadFormConversionEvent() {
      pushPopupAnalyticsEvent('leadFormConversion', this.content)
    },
    pushGatedContentConversionEvent() {
      pushPopupAnalyticsEvent('gatedContentConversion', this.content, {
        requestedContent: this.content.gatedContent.requestedContent,
      })
    },
    pushCaseStudyClickedEvent(item) {
      pushPopupAnalyticsEvent('caseStudyClicked', this.content, {
        caseStudyClicked: item.title,
      })
    },
  },
}
</script>

<style scoped>

.MultichoiceOptionPane {
  height: 100vh;
}

@media (--screen-lg) {
  .MultichoiceOptionPane {
    height: auto;
  }
}
</style>
